import React from 'react';
import ReactSpinner from 'react-spinner';

const Spinner = ({ className }) => (
  <div style={{ padding: '120px 0' }}>
    <ReactSpinner className={className} />
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js